import axios from "axios";
import { decode, encode } from "base-64";

import { ParametrosWSBase, DestinoConexion } from "./ParametrosWSBase";
import { EncabezadoRespuestaInterna } from "./EncabezadoRespuestaInterna";

if (!global.btoa) {
  global.btoa = encode;
}

if (!global.atob) {
  global.atob = decode;
}

export const ConsultaWS = async (parametrosEntrada: ParametrosWSBase) => {
  var rutaDominio: string | undefined = "";
  const encabezadoInterno = EncabezadoRequestRest(parametrosEntrada);
  var parametros = { ...parametrosEntrada.parametros };
  var encabezadoContenido: string = "application/json; charset=UTF-8";
  var encabezadoAutorizacion: string = "";
  var basicAut = {};
  var basicAuth = {};
  var CRC = parametrosEntrada.cRC;
  let lesta: boolean = false;
  let crateso: boolean = false;

  const { REACT_APP_LOCAL } = process.env;
  const {
    REACT_APP_URL_BACKEND,
    REACT_APP_USUARIO_BACKEND,
    REACT_APP_CONTRA_BACKEND,
    REACT_APP_URL_AVATAR,
    REACT_APP_URL_BACKEND_SELFSERVICE,
    REACT_APP_URL_BACKEN_SF,
  } = process.env;
  switch (parametrosEntrada.DESTINO_SERVICIO) {
    case DestinoConexion.Backend:
      rutaDominio = REACT_APP_URL_BACKEND;
      parametros = { ...encabezadoInterno, ...parametrosEntrada.parametros! };
      basicAut = {
        auth: {
          username: REACT_APP_USUARIO_BACKEND,
          password: REACT_APP_CONTRA_BACKEND,
        },
      };
      break;

    case DestinoConexion.BackendBilletera:
      rutaDominio = REACT_APP_URL_BACKEND;
      parametros = { ...encabezadoInterno, ...parametrosEntrada.parametros! };
      basicAut = {
        auth: {
          username: REACT_APP_USUARIO_BACKEND,
          password: REACT_APP_CONTRA_BACKEND,
        },
      };
      break;

    case DestinoConexion.Avatars:
      rutaDominio = REACT_APP_URL_AVATAR;
      parametros = { ...parametrosEntrada.parametros! };
      basicAut = {
        auth: {
          username: REACT_APP_USUARIO_BACKEND,
          password: REACT_APP_CONTRA_BACKEND,
        },
      };
      break;

    case DestinoConexion.BackendSelfService:
      rutaDominio = REACT_APP_URL_BACKEND_SELFSERVICE;
      parametros = { ...parametrosEntrada.parametros! };
      basicAut = {
        auth: {
          username: REACT_APP_USUARIO_BACKEND,
          password: REACT_APP_CONTRA_BACKEND,
        },
      };
      break;

    case DestinoConexion.BackendSF:
      rutaDominio = REACT_APP_URL_BACKEN_SF;
      parametros = { ...encabezadoInterno, ...parametrosEntrada.parametros! };
      basicAut = {
        auth: {
          username: REACT_APP_USUARIO_BACKEND,
          password: REACT_APP_CONTRA_BACKEND,
        },
      };
      break;

    case DestinoConexion.Proxy:
      rutaDominio = REACT_APP_LOCAL;
      parametros = {
        ...encabezadoInterno,
        ...parametrosEntrada.parametros!,
        accountNumber: returnAccountNumber(parametrosEntrada),
      };
      lesta = true;
      crateso = true;

      break;
  }

  //console.info("end point servicio: ", `${rutaDominio}${parametrosEntrada.rutaEndPoint}`);
  //console.info("json reques:", parametros);
  try {
    const requestHeaders: {
      "Content-Type": string;
      Authorization: string;
      Accept: string;
      AcceptCRC: string;
      "X-MY-SKY-SESSION-ID"?: string;
      "X-MY-SKY-ACCOUNT-NUMBER"?: string;
    } = {
      "Content-Type": encabezadoContenido,
      Authorization: `${encabezadoAutorizacion}`,
      Accept: "application/json",
      AcceptCRC: `${CRC}`,
    };

    if (sessionStorage.getItem("tonpla") && lesta) {
      requestHeaders["X-MY-SKY-SESSION-ID"] =
        sessionStorage.getItem("tonpla") ?? "";
    }
    const flujo = sessionStorage.getItem("flujos");

    if (sessionStorage.getItem("tonpla") && crateso) {
      requestHeaders["X-MY-SKY-ACCOUNT-NUMBER"] =
        flujo === "Sky+"
          ? sessionStorage.getItem("cuenta")!
          : sessionStorage.getItem("cuenta")! ?? "";
    }

    const response = await axios.post(
      `${rutaDominio}${parametrosEntrada.rutaEndPoint}`,
      parametros,
      {
        headers: requestHeaders,
        ...basicAut,
      }
    );

    const { data, status, headers: responseHeaders } = response;

    if (response.headers["x-my-sky-session-id"] && lesta) {
      sessionStorage.setItem("tonpla", responseHeaders["x-my-sky-session-id"]);
    }

    return JSON.parse(JSON.stringify(data, null, 4));
  } catch (error) {
    let resp: EncabezadoRespuestaInterna = {
      EBMHeaderResponse: {
        ErrorTecnico: {
          code: "",
          summary: "",
          detail: "",
          Sistema: "",
        },
        ErrorNegocio: {
          Estado: "",
          CodigoError: "-1",
          DescripcionError: "",
        },
      },
    };
    if (axios.isAxiosError(error)) {
      const { response } = error;
      if (
        response?.status === 401 &&
        response.data?.api_error?.code === "API-001"
      ) {
        // Limpiar la sesión y redirigir al usuario al login
        alert("La sesión ha expirado.");
        sessionStorage.clear(); // Limpia todo el sessionStorage
        window.location.href = "/login"; // Redirigir usando window.location.href
      }
      console.error("error: ", parametrosEntrada.nombreProceso, error.message);
      resp.EBMHeaderResponse.ErrorNegocio.DescripcionError = error.message;

      return resp;
    } else {
      console.error(
        "unexpected error: ",
        parametrosEntrada.nombreProceso,
        error
      );
      resp.EBMHeaderResponse.ErrorNegocio.DescripcionError =
        "unexpected error: " + error;
      return resp;
    }
  }
};

export const ConsultaWSGet = async (parametrosEntrada: ParametrosWSBase) => {
  var rutaDominio: string | undefined = "";
  var parametros = { ...parametrosEntrada.parametros };
  var encabezadoContenido: string = "application/json; charset=UTF-8";
  var encabezadoAutorizacion: string = "";
  var basicAut = {};
  const {
    REACT_APP_URL_BACKEND,
    REACT_APP_USUARIO_BACKEND,
    REACT_APP_CONTRA_BACKEND,
    REACT_APP_URL_AVATAR,
    REACT_APP_URL_BACKEND_SELFSERVICE,
    REACT_APP_URL_BACKEN_SF,
  } = process.env;
  switch (parametrosEntrada.DESTINO_SERVICIO) {
    case DestinoConexion.Avatars:
      rutaDominio = REACT_APP_URL_AVATAR;
      parametros = { ...parametrosEntrada.parametros! };
      basicAut = {
        auth: {
          username: REACT_APP_USUARIO_BACKEND,
          password: REACT_APP_CONTRA_BACKEND,
        },
      };
      break;
  }

  try {
    const { data, status } = await axios.get(
      `${rutaDominio}${parametrosEntrada.rutaEndPoint}`,
      {
        headers: {
          "Content-Type": encabezadoContenido,
          Authorization: `${encabezadoAutorizacion}`,
          Accept: "application/json",
        },
        ...basicAut,
      }
    );

    return JSON.parse(JSON.stringify(data, null, 4));
  } catch (error) {
    let resp: EncabezadoRespuestaInterna = {
      EBMHeaderResponse: {
        ErrorTecnico: {
          code: "",
          summary: "",
          detail: "",
          Sistema: "",
        },
        ErrorNegocio: {
          Estado: "",
          CodigoError: "-1",
          DescripcionError: "",
        },
      },
    };
    if (axios.isAxiosError(error)) {
      console.error("error: ", parametrosEntrada.nombreProceso, error.message);
      resp.EBMHeaderResponse.ErrorNegocio.DescripcionError = error.message;

      return resp;
    } else {
      console.error(
        "unexpected error: ",
        parametrosEntrada.nombreProceso,
        error
      );
      resp.EBMHeaderResponse.ErrorNegocio.DescripcionError =
        "unexpected error: " + error;
      return resp;
    }
  }
};

function EncabezadoRequestRest(par: ParametrosWSBase) {
  if (
    par.DESTINO_SERVICIO == DestinoConexion.BackendBilletera ||
    par.DESTINO_SERVICIO == DestinoConexion.Proxy
  ) {
    return {
      EBMHeaderRequest: {
        Operacion: par.nombreProceso,
        SistemaOrigen: par.sistemaOrigen,
      },
    };
  }

  return {};
}

const returnAccountNumber = (parametrosEntrada: ParametrosWSBase) => {
  // Obtiene directamente el valor de sessionStorage sin usar useState
  const flujo = sessionStorage.getItem("flujos");

  if (
    parametrosEntrada.rutaEndPoint.includes("AutenticarUsuarioRest") ||
    parametrosEntrada.rutaEndPoint.includes("PreRegistroRest") ||
    parametrosEntrada.rutaEndPoint.includes("restablecerContrasena") ||
    parametrosEntrada.rutaEndPoint.includes("ReEnviarEmailPreRegSelEBSRest")
  ) {
    // Para estos endpoints, no devuelve nada
    return "";
  } else {
    // Devuelve el número de cuenta en función del flujo
    return flujo === "Sky+"
      ? sessionStorage.getItem("cuenta")!
      : sessionStorage.getItem("cuenta")! ?? "";
  }
};
function dispatch(arg0: string) {
  throw new Error("Function not implemented.");
}
